import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AccountWebPageBasicInfoComponent = ({ isDefaultWebPage,accounts,onInnerFormChange, selectedWebpages , pages, accountTypes}: any) => (
  
    <>
    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
          label="Account Type"
          labelField="Name"
          list={accountTypes}
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'AccountTypeId',
            );
          }}
          optionName='Choose AccountType'
          type="select"
          value={selectedWebpages?.AccountTypeId}
          valueField="Id"
        />
        {!isDefaultWebPage &&
         <InputContainer
          label="Account Name"
          labelField="Name"
          list={accounts}
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'AccountId',
            );
          }}
          optionName='Choose Account Name'
          type="select"
          value={selectedWebpages?.AccountId}
          valueField="Id"
          />}
         <InputContainer
          label="Page Name"
          labelField="PageName"
          list={pages}
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'PlatformWebSitePageId',
            );
          }}
          optionName='Choose Platform  WebPage'
          type="select"
          value={selectedWebpages?.PlatformWebSitePageId}
          valueField="Id"
        />
        
<InputContainer

label="WebPage Version"
name="WebPageVersionId"
onValueChange={(event: any) => {
  onInnerFormChange(
    event.target.value,
     'WebPageVersionId',

       )
     }}
 type="number"
 value={selectedWebpages?.WebPageVersionId}
/>
<InputContainer

label="Hosting Url"
name="HostingUrl"
onValueChange={(event: any) => {
  onInnerFormChange(
    event.target.value,
     'HostingUrl',

       )
     }}
 type="text"
 value={selectedWebpages?.HostingUrl}
/>
<InputContainer

label="Mapped Domain"
name="MappedDomain"
onValueChange={(event: any) => {
  onInnerFormChange(
    event.target.value,
     'MappedDomain',

       )
     }}
 type="text"
 value={selectedWebpages?.MappedDomain}
/>  
<InputContainer

label="Display Order"
name="DisplayOrder"
onValueChange={(event: any) => {
  onInnerFormChange(
    event.target.value,
     'DisplayOrder',

       )
     }}
 type="number"
 value={selectedWebpages?.DisplayOrder}
/> 
<InputContainer

label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  onInnerFormChange(
    event.target.value,
     'Remarks',

       )
     }}
 type="text"
 value={selectedWebpages?.Remarks}
/> 
        
        </div>
    </>
)
